export class MenuConfig {
  public workflowMenu = {
    title: 'Workflow',
    tooltip: 'Workflow',
    permission: 'accessToWorkflowMenuModule',
    translate: 'WORKFLOW.WORKFLOWS',
    root: true,
    bullet: 'dot',
    icon: ' fab fa-trello',
    submenu: [],
  };
  public linkGroupMenu = {
    title: 'Links',
    tooltip: 'Links',
    permission: 'canViewLinks',
    translate: 'MENU.LINKS',
    root: true,
    bullet: 'dot',
    icon: 'flaticon2-paper-plane',
    submenu: [],
  };

  public complianceMenu = {
    title: 'Compliance',
    tooltip: 'Compliance',
    permission: 'accessCompliance',
    translate: 'MENU.COMPLIANCE.TITLE',
    root: true,
    bullet: 'dot',
    icon: 'flaticon2-checking',
    submenu: [
      {
        title: 'Agencies',
        permission: 'accessComplianceAgencies',
        translate: 'MENU.COMPLIANCE.AGENCIES',
        page: '/compliance/agencies',
      },
      {
        title: 'Programs',
        permission: 'accessCompliancePrograms',
        translate: 'MENU.COMPLIANCE.PROGRAMS',
        page: '/compliance/programs',
      },
      {
        title: 'Standards',
        permission: 'accessComplianceStandards',
        translate: 'MENU.COMPLIANCE.STANDARDS',
        page: '/compliance/standards',
      },
      {
        title: 'Reporting',
        permission: 'accessComplianceReporting',
        translate: 'MENU.COMPLIANCE.REPORTING',
        page: '/compliance/reporting',
      },
    ],
  };

  public bridgePay = {
    title: 'BridgePay',
    tooltip: 'BridgePay',
    hidden: true,
    permission: 'accessToBridgePayModule',
    translate: 'MENU.BRIDGEPAY.TITLE',
    root: true,
    bullet: 'dot',
    svgIconInline: 'assets/media/svg/icons/General/dollar.svg',
    submenu: [
      {
        title: 'Transaction History',
        permission: 'canViewTransactionHistory',
        translate: 'MENU.BRIDGEPAY.TRANSACTION_HISTORY',
        page: '/bridgepay/transactionHistory',
      },
    ],
  };

  public conceptsManagementMenu = {
    title: 'Concepts Management',
    tooltip: 'Concepts Management',
    permission: 'accessToConceptsManagement',
    translate: 'CONCEPTS_MODULE.TITLES.CONCEPTS_MANAGEMENT',
    root: true,
    bullet: 'dot',
    icon: 'fa fa-lightbulb',
    submenu: [
      {
        title: 'Dictionaries',
        permission: 'accessToDictionaries',
        translate: 'CONCEPTS_MODULE.TITLES.DICTIONARIES',
        page: '/concepts-manage/dictionaries',
      },
      {
        title: 'Knostos Concepts',
        permission: 'accessToConcepts',
        translate: 'CONCEPTS_MODULE.TITLES.CONCEPTS',
        page: '/concepts-manage/concepts',
      },
      {
        title: 'Synonyms',
        permission: 'accessToSynonyms',
        translate: 'CONCEPTS_MODULE.TITLES.SYNONYMS',
        page: '/concepts-manage/synonyms',
      },
    ],
  };

  public formsTemplatesMenu = {
    title: 'Forms & Templates',
    tooltip: 'Forms & Templates',
    permission: 'accessToFormsTemplates',
    translate: 'FORMS_TEMPLATES_MODULE.TITLES.FORMS_TEMPLATES',
    root: true,
    bullet: 'dot',
    icon: 'flaticon2-website',
    submenu: [
      {
        title: 'Forms',
        permission: 'accessToForms',
        translate: 'FORMS_TEMPLATES_MODULE.TITLES.FORMS',
        page: '/forms-templates/forms',
      },
      {
        title: 'Document Templates',
        permission: 'accessToDocumentTemplates',
        translate: 'FORMS_TEMPLATES_MODULE.TITLES.DOCUMENT_TEMPLATES',
        page: '/forms-templates/templates',
      },
      {
        title: 'Form-Template Mapping',
        permission: 'accessToFormTemplateMapping',
        translate: 'FORMS_TEMPLATES_MODULE.TITLES.FORM_TEMPLATE_MAPPING',
        page: '/forms-templates/mapping',
      },
      {
        title: 'Form AI Agent Beta',
        permission: 'accessToFormAiAgent',
        translate: 'FORMS_TEMPLATES_MODULE.TITLES.FORM_AI_AGENT',
        page: '/forms-templates/ai-agent',
      },
    ],
  };

  public documentsManagementMenu = {
    title: 'Documents Management',
    permission: 'accessToDocumentsManagement',
    translate: 'DOCS_MODULE.TITLES.DOCUMENTS_MANAGEMENT',
    root: true,
    bullet: 'dot',
    submenu: [
      {
        title: 'Categories & Sharing Configs',
        permission: 'accessDocumentCategory',
        translate: 'DOCS_MODULE.TITLES.CATEGORIES_SHARING',
        page: '/management/docs/categories',
      },
      {
        title: 'Documents Library',
        permission: 'accessDocument',
        translate: 'DOCS_MODULE.TITLES.DOCUMENTS',
        page: '/management/docs/library',
      },
      {
        title: 'Access History',
        permission: 'canViewDocumentAccessHistory',
        translate: 'DOCS_MODULE.TITLES.ACCESS_HISTORY',
        page: '/management/docs/access-history',
      },
    ],
  };

  public activityTrackingMenu = {
    title: 'Activity Tracking',
    permission: 'accessToActivityTracking',
    translate: 'MENU.ACTIVITY_TRACKING',
    root: true,
    bullet: 'dot',
    submenu: [
      {
        title: 'Activity Templates',
        permission: 'accessToActivityTemplates',
        translate: 'MENU.ACTIVITY_TEMPLATES',
        page: '/management/activity-tracking/templates',
      },
      {
        title: 'Activities',
        permission: 'accessToActivities',
        translate: 'MENU.ACTIVITIES',
        page: '/management/activity-tracking/activities',
      },
    ],
  };

  public statementsCollectionsSettingsMenu = {
    title: 'Statements & Collections',
    permission: 'accessToStatementsCollections',
    translate: 'MENU.STATEMENTS_COLLECTIONS',
    root: true,
    bullet: 'dot',
    submenu: [
      {
        title: 'Settings',
        permission: 'accessToStatementsCollectionsSettings',
        translate: 'MENU.SETTINGS',
        page: '/management/statements-collections/settings',
      },
    ],
  };

  public statementsCollectionsAppMenu = {
    title: 'Statements & Collections',
    permission: 'accessToStatementsCollections',
    translate: 'MENU.STATEMENTS_COLLECTIONS',
    root: true,
    bullet: 'dot',
    icon: 'flaticon2-folder',
    submenu: [
      {
        title: 'Statements',
        permission: 'accessToStatements',
        translate: 'MENU.STATEMENTS',
        root: true,
        bullet: 'dot',
        submenu: [
          {
            title: 'Dashboard',
            permission: 'accessToStatementDashboard',
            translate: 'MENU.DASHBOARD',
            page: '/management/statements-collections/statements/dashboard',
          },
          {
            title: 'Templates Mapping',
            permission: 'accessToStatementTemplatesMapping',
            translate: 'MENU.TEMPLATES_MAPPING',
            page: '/management/statements-collections/statements/templates-mapping',
          },
        ],
      },
    ],
  };

  public qrvey = {
    title: 'Analytics',
    tooltip: 'Analytics',
    translate: 'QRVEY.ANALYTICS',
    permission: 'accessAnalyticsAccessList',
    bullet: 'dot',
    icon: 'flaticon-graphic-2',
    root: true,
    submenu: [],
  };
  private inboxesMenu: {
    submenu: (
      | {
          tooltip: string;
          icon: string;
          permission: string;
          page: string;
          title: string;
          bullet: string;
          translate: string;
        }
      | {
          tooltip: string;
          icon: string;
          page: string;
          title: string;
          bullet: string;
          translate: string;
        }
    )[];
    root: boolean;
    permission: string;
    title: string;
    bullet: string;
    translate: string;
  };

  public defaults: any = {
    aside: {
      items: [
        {
          title: 'Dashboard',
          tooltip: 'Dashboard',
          icon: 'flaticon2-architecture-and-city',
          page: '/dashboard',
          translate: 'MENU.DASHBOARD',
          bullet: 'dot',
        },
        { section: 'Applications' },
        this.linkGroupMenu,
        this.qrvey,
        {
          title: 'Care Management',
          tooltip: 'Care Management',
          permission: 'accessToRemoteMonitoringModule',
          root: true,
          bullet: 'dot',
          icon: 'flaticon2-analytics-2',
          page: '/workflow',
          submenu: [
            {
              title: 'Remote Patient Monitoring',
              permission: 'accessToDeviceMenu',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Device list',
                  translate: 'MENU.DEVICES_LIST',
                  permission: 'accessToDeviceModule',
                  page: '/me/devices',
                },
                {
                  title: 'Device Types',
                  permission: 'accessToDeviceTypeModule',
                  page: '/me/devices-types',
                },
                {
                  title: 'Devices Inventory',
                  // translate: 'ME.INVENTORY',
                  permission: 'accessToDeviceInventoryModule',
                  page: '/me/devices-inventory',
                },
              ],
            },
            {
              title: 'Care Coordination',
              bullet: 'dot',
              root: true,
              permission: 'accessToProgramMenu',
              submenu: [
                {
                  title: 'Program List',
                  permission: 'accessToProgramModule',
                  page: '/me/admin-program',
                },
              ],
            },
          ],
        },
        this.complianceMenu,
        this.conceptsManagementMenu,
        this.formsTemplatesMenu,
        this.statementsCollectionsAppMenu,
        {
          title: 'CRM',
          tooltip: 'CRM',
          root: true,
          bullet: 'dot',
          permission: 'accessToSaleModule',
          icon: 'flaticon-suitcase',
          page: '/sale',
          submenu: [
            {
              title: 'Document Library',
              translate: 'SALE.DOC_LIB',
              permission: 'accessToDocumentLibraryModule',
              page: '/sale/document-library',
            },
            {
              title: 'Sales Calls',
              permission: 'accessToMeetingModule',
              translate: 'MEETING.MEETINGS',
              page: '/timeline/meetings',
            },
            {
              title: 'Sales Teams',
              permission: 'accessToSalesTeamsModule',
              page: '/timeline/sales-team',
            },
          ],
        },
        {
          title: 'Legacy Workflows',
          tooltip: 'Legacy Workflows',
          permission: 'accessToEventLegacies',
          icon: 'flaticon-reply',
          page: '/event-legacies',
          translate: 'MENU.LEGACY_WORKFLOWS',
          bullet: 'dot',
        },
        {
          title: 'Task',
          tooltip: 'Task',
          permission: 'accessToTaskModule',
          page: '/task/list',
          icon: ' fa fa-tasks',
          bullet: 'dot',
          root: true,
        },
        // {
        //   title: 'Inbox',
        //   tooltip: 'Inbox',
        //   permission: 'accessToInboxModule',
        //   icon: 'flaticon2-email',
        //   page: '/events/inbox',
        //   translate: 'MENU.INBOX',
        //   bullet: 'dot',
        // },
        {
          title: 'Inbox App',
          tooltip: 'Inbox App',
          permission: 'accessToInboxModule',
          icon: 'flaticon2-email',
          page: '/email-fax/inbox-app',
          translate: 'MENU.INBOX',
          bullet: 'dot',
        },
        {
          title: 'MedReview',
          tooltip: 'MedReview',
          permission: 'accessMedReview',
          icon: 'flaticon2-writing',
          page: '/med-review',
          translate: 'MENU.MED_REVIEW',
          bullet: 'dot',
        },
        this.bridgePay,
        { section: 'Utilities' },
        {
          title: 'Received Document',
          tooltip: 'Received Document',
          permission: 'accessToReceivedDocument',
          icon: 'flaticon-doc',
          page: '/events/received-document',
          bullet: 'dot',
        },
        {
          title: 'Alerts & Notifications Log',
          tooltip: 'Alerts & Notifications Log',
          permission: 'accessToReceivedDocument',
          icon: 'flaticon-responsive',
          page: '/alerts-notifications-log',
          bullet: 'dot',
        },
        {
          title: 'Enrollment Verification',
          tooltip: 'Enrollment Verification',
          permission: 'accessToEnrollmentModule',
          icon: 'flaticon-responsive',
          page: '/enrollment-verification',
          bullet: 'dot',
        },

        { section: 'Lists' },
        {
          title: 'Primary Lists',
          tooltip: 'Primary Lists',
          translate: 'GLOBAL.ENTITY',
          permission: 'accessToEntityModule',
          icon: 'flaticon2-correct',
          bullet: 'dot',
          root: true,
          submenu: [
            {
              title: 'Doctor',
              permission: 'accessToDoctorModule',
              translate: 'MENU.DOCTOR',
              page: '/lists/doctors',
            },
            {
              title: 'Patient',
              permission: 'accessToPatientModule',
              translate: 'MENU.PATIENT',
              page: '/lists/patients',
            },
            {
              title: 'Contact',
              permission: 'accessToContactModule',
              translate: 'MENU.CONTACT',
              page: '/lists/contacts',
            },
            {
              title: 'Facility',
              permission: 'accessToFacilityModule',
              translate: 'MENU.FACILITY',
              page: '/lists/facilities',
            },
          ],
        },
        {
          title: 'Other Lists',
          tooltip: 'Other Lists',
          translate: 'MENU.LISTS',
          permission: 'accessToListsModule',
          bullet: 'dot',
          icon: 'flaticon2-list-2',
          root: true,
          submenu: [
            {
              title: 'Pharmacy',
              translate: 'MENU.PHARMACY',
              permission: 'accessToPharmacyMenu',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Pharmacy List',
                  permission: 'accessToPharmacyModule',
                  translate: 'MENU.PHARMACY_LIST',
                  page: '/lists/pharmacies',
                },
                {
                  title: 'Pharmacy Group',
                  permission: 'accessToPharmacyGroupModule',
                  translate: 'MENU.PHARMACY_GROUP',
                  page: '/lists/pharmacy-groups',
                },
              ],
            },
            {
              title: 'Drug',
              translate: 'MENU.DRUG',
              permission: 'accessToDrugMenu',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Drug List',
                  permission: 'accessToDrugModule',
                  translate: 'MENU.DRUG_LIST',
                  page: '/lists/drugs',
                },
                {
                  title: 'Drug Group',
                  permission: 'accessToDrugGroupModule',
                  translate: 'MENU.DRUG_GROUP',
                  page: '/lists/drug-groups',
                },
              ],
            },
            {
              title: 'Contact Relationship',
              translate: 'MENU.CONTACT_RELATIONSHIP',
              permission: 'accessToContactRelationshipModule',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Category',
                  permission: 'accessToRelationshipCategoryModule',
                  translate: 'MENU.RELATIONSHIP_CATEGORY',
                  page: '/lists/RelationshipCategory',
                },
                {
                  title: 'Description',
                  permission: 'accessToCategoryDescriptionModule',
                  translate: 'MENU.CATEGORY_DESCRIPTION',
                  page: '/lists/CategoryDescription',
                },
              ],
            },
            {
              title: 'Affiliation',
              permission: 'accessToAffiliationModule',
              translate: 'MENU.AFFILIATION',
              page: '/lists/affiliations',
            },
            {
              title: 'Affiliation Type',
              permission: 'accessToAffiliationTypeModule',
              translate: 'MENU.AFFILIATION_TYPE',
              page: '/lists/affiliationTypes',
            },
            {
              title: 'Client',
              permission: 'accessToClientModule',
              translate: 'MENU.CLIENT',
              page: '/lists/clients',
            },
            {
              title: 'Insurance',
              permission: 'accessToInsuranceModule',
              translate: 'MENU.INSURANCE',
              page: '/lists/insurances',
            },
            {
              title: 'Programs',
              permission: 'accessToProgramsModule',
              page: '/me/program',
            },
            {
              title: 'Problem List',
              permission: 'accessToProgramsModule',
              page: '/me/problem',
            },
            {
              title: 'Assign programs',
              permission: 'accessToCompanyProgramsModule',
              page: '/me/assign-company-program',
            },
            {
              title: 'Manage Notifications',
              permission: 'accessManageNotifications',
              translate: 'MENU.MANAGE_NOTIFICATIONS',
              page: '/notifications',
            },
          ],
        },
        { section: 'Settings' },
        {
          title: 'Events',
          tooltip: 'Events',
          permission: 'accessToEventsModule',
          translate: 'MENU.EVENTS',
          bullet: 'dot',
          icon: 'flaticon2-checking',
          root: true,
          submenu: [
            {
              title: 'Action',
              permission: 'accessToActionModule',
              translate: 'MENU.ACTION',
              page: '/events/event-actions',
            },
            {
              title: 'Event',
              permission: 'accessToEventModule',
              translate: 'MENU.EVENT',
              page: '/events/event-events',
            },
            {
              title: 'Workflow',
              permission: 'accessToWorkflowModule',
              translate: 'MENU.WORKFLOW',
              page: '/events/event-workflows',
            },
            {
              title: 'API',
              permission: 'accessToApiModule',
              translate: 'MENU.API',
              page: '/events/apis',
            },
          ],
        },
        {
          title: 'Management',
          tooltip: 'Management',
          permission: 'accessToManagementModule',
          translate: 'MENU.MANAGEMENT',
          bullet: 'dot',
          icon: 'flaticon2-user-outline-symbol',
          root: true,
          submenu: [
            {
              title: 'QRVEY Applications',
              permission: 'accessAnalyticsAccessList',
              bullet: 'dot',
              page: '/lists/applications',
            },
            // {
            //   title: 'Analytics Access',
            //   permission: 'accessAnalyticsAccessList',
            //   bullet: 'dot',
            //   root: true,
            //   submenu: [
            //     {
            //       title: 'Page Group',
            //       permission: 'accessToPageGroupList',
            //       page: '/lists/PageGroupListComponent'
            //     },
            //     {
            //       title: 'Internal Access',
            //       permission: 'accessToInternalAccessList',
            //       page: '/lists/InternalAccessList'
            //     },
            //     {
            //       title: 'External Access',
            //       permission: 'accessToExternalAccessList',
            //       page: '/lists/ExternalAccessList'
            //     }
            //   ]
            // },
            {
              title: 'Lookup Lists',
              translate: 'MENU.CONTACT_RELATIONSHIP',
              permission: 'accessToContactRelationshipModule',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'DRP Reason',
                  permission: 'accessToDRPReasonModule',
                  translate: 'MENU.REASON_DRP',
                  page: '/lists/reasons',
                },
                {
                  title: 'Follow-up Reason',
                  permission: 'accessToFollowupReasonModule',
                  translate: 'MENU.REASON_FOLLOWUP',
                  page: '/lists/FollowupReasons',
                },
                {
                  title: 'Category',
                  permission: 'accessToRelationshipCategoryModule',
                  translate: 'MENU.RELATIONSHIP_CATEGORY',
                  page: '/lists/RelationshipCategory',
                },
                {
                  title: 'Description',
                  permission: 'accessToCategoryDescriptionModule',
                  translate: 'MENU.CATEGORY_DESCRIPTION',
                  page: '/lists/CategoryDescription',
                },
              ],
            },
            {
              title: 'User Management',
              permission: 'accessToUserManagementMenu',
              translate: 'MENU.USER_MANAGEMENT',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'User',
                  translate: 'MENU.USER',
                  permission: 'accessToUserManagementModule',
                  page: '/user-management/users',
                },
                {
                  title: 'Role',
                  translate: 'MENU.ROLE',
                  permission: 'accessToRoleModule',
                  page: '/user-management/roles',
                },
                {
                  title: 'Role Template',
                  translate: 'MENU.ROLE_TEMPLATES',
                  permission: 'accessToRoleTemplateModule',
                  page: '/user-management/role-templates',
                },
                {
                  title: 'Team',
                  page: '/lists/team',
                  permission: 'accessToTeamModule',
                },
              ],
            },
            {
              title: 'Communications',
              permission: 'accessToCommunications',
              translate: 'MENU.COMMUNICATIONS',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Fax',
                  tooltip: 'Fax',
                  permission: 'accessToFaxModule',
                  page: 'email-fax/fax-list',
                  translate: 'MENU.FAX',
                },
                {
                  title: 'Email',
                  tooltip: 'Email',
                  permission: 'accessToEmailModule',
                  page: 'email-fax/email-list',
                  translate: 'MENU.EMAIL',
                },
                {
                  title: 'Inbox',
                  tooltip: 'Inbox',
                  permission: 'accessToInboxManagementModule',
                  page: 'email-fax/inbox-list',
                  translate: 'MENU.INBOX',
                },
              ],
            },
            {
              title: 'Agreement Management',
              permission: 'accessToAgreementManagementMenu',
              translate: 'MENU.AGREEMENT_MANAGEMENT',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Agreement List',
                  translate: 'MENU.AGREEMENT_LIST',
                  permission: 'accessToAgreementModule',
                  page: '/agreement-management/list',
                },
                {
                  title: 'Template List',
                  translate: 'MENU.AGREEMENT_TEMPLATE',
                  permission: 'accessToAgreementTemplateModule',
                  page: '/agreement-management/templates',
                },
              ],
            },
            this.documentsManagementMenu,
            this.activityTrackingMenu,
            this.statementsCollectionsSettingsMenu,
            {
              title: 'Webhooks',
              permission: 'accessToWebhooksMenu',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Credential list',
                  permission: 'accessToWebhookCredential',
                  page: '/management/credential-webhook',
                },
                {
                  title: 'Active Webhook list',
                  page: '/management/active-webhook',
                  permission: 'accessToActiveWebhook',
                },
              ],
            },
            {
              title: 'Link Management',
              permission: 'accessToLinkModule',
              translate: 'MENU.LINK_MANAGEMENT',
              bullet: 'dot',
              root: true,
              submenu: [
                {
                  title: 'Link Groups',
                  permission: 'accessToLinkModule',
                  translate: 'MENU.LINK_GROUPS',
                  page: '/management/link-groups',
                },
                {
                  title: 'Links',
                  permission: 'accessToLinkModule',
                  translate: 'MENU.LINKS',
                  page: '/management/links',
                },
              ],
            },
            {
              title: 'Task Template',
              permission: 'accessToTemplateModule',
              translate: 'MENU.TEMPLATE',
              page: '/lists/template',
            },
            {
              title: 'Actions',
              permission: 'accessToTemplateModule',
              translate: 'MENU.ACTIONS',
              page: '/lists/actions',
            },
            {
              title: 'Activity Log',
              page: '/activity-log',
              permission: 'accessToActivityLogModule',
              translate: 'MENU.ACTIVITY_LOG',
              bullet: 'dot',
            },
            {
              title: 'Login Log',
              page: '/login-log',
              permission: 'accessToAuthLogs',
              translate: 'MENU.LOGIN_LOG',
              bullet: 'dot',
            },
            {
              title: 'Company',
              permission: 'accessToCompanyModule',
              translate: 'MENU.COMPANY',
              page: '/management/companies',
            },
            {
              title: 'WorkOS',
              permission: 'accessToWorkOSModule',
              translate: 'MENU.WORKOS',
              page: '/management/workOS',
            },
            {
              title: 'Allowed Origins',
              permission: 'accessToCORSModule',
              translate: 'MENU.ALLOWED_ORIGINS',
              page: '/management/allowed-origins',
            },
            {
              title: 'Office',
              permission: 'accessToOfficeModule',
              translate: 'MENU.OFFICE',
              page: '/management/offices',
            },
            {
              title: 'Service Catalog',
              permission: 'accessToServiceCatalogs',
              translate: 'MENU.SERVICE_CATALOG',
              page: '/management/service-catalogs',
            },
            {
              title: 'Tags',
              permission: 'accessToTagsModule',
              translate: 'MENU.TAGS',
              page: '/lists/tags',
            },
            { section: ' ' },
          ],
        },
      ],
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
